import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseButton from "../../components/BaseButton";
import useModalActions from "../../hooks/useModalActions";
import useController from "./controller";
import { useTranslation } from "react-i18next";

export default function RemoveUser() {
  const { closeModal } = useModalActions();
  const { isDeleting, deleteProfile } = useController();
  const { t } = useTranslation();

  return (
    <BaseModal
      title={t("modals.remove_user.title")}
      className="remove-game-modal"
      eventTypeModal={MODAL_TYPES.REMOVE_PROFILE}
    >
      <BaseButton
        negative={true}
        loading={isDeleting}
        typeSpinner="light"
        onClick={deleteProfile}
      >
        {t("modals.remove_user.remove")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        className="modal-button-cancel"
        onClick={() => closeModal(MODAL_TYPES.REMOVE_PROFILE)}
      >
        {t("modals.remove_user.cancel")}
      </BaseButton>
    </BaseModal>
  );
}
